<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-3">
        <table class="table table-sm table-bordered">
          <colgroup>
            <col style="width: 50%">
            <col style="width: 50%">
          </colgroup>
          <tr>
            <th class="text-center font-weight-normal">
              Activar
            </th>
            <td class="text-center">
              <b-form-checkbox
                id="checkbox-dst"
                class="d-inline"
                v-model="itemData.enableDST"
              />
            </td>
          </tr>
        </table>
      </div>
    </div>
    <p class="h6 font-weight-bolder">Inicio</p>
    <div class="border-section rounded p-1 mb-2">
      <div class="row">
        <div class="col-3">
          <b-form-group label="Mes">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="monthsDST"
              class="w-100 datetime-select"
              :reduce="(val) => val.value"
              v-model="itemData.startMonthDst"
              append-to-body
              :clearable="false"
              :disabled="disabledInputsDst"
              :calculate-position="withPopper"
            />
          </b-form-group>
        </div>
        <div class="col-3">
          <b-form-group label="Semana">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="weeksDST"
              class="w-100 datetime-select"
              :reduce="(val) => val.value"
              v-model="itemData.startWeekDst"
              append-to-body
              :clearable="false"
              :disabled="disabledInputsDst"
              :calculate-position="withPopper"
            />
          </b-form-group>
        </div>
        <div class="col-3">
          <b-form-group label="Día">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="daysDST"
              class="w-100 datetime-select"
              :reduce="(val) => val.value"
              v-model="itemData.startDayDst"
              append-to-body
              :clearable="false"
              :disabled="disabledInputsDst"
              :calculate-position="withPopper"
            />
          </b-form-group>
        </div>
        <div class="col-3">
          <b-form-group label="Hora">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="hoursDst"
              class="w-100 datetime-select"
              :reduce="(val) => val.value"
              v-model="itemData.startHourDst"
              append-to-body
              :clearable="false"
              :disabled="disabledInputsDst"
              :calculate-position="withPopper"
            />
          </b-form-group>
        </div>
      </div>
    </div>
    <p class="h6 font-weight-bolder">Fin</p>
    <div class="border-section rounded p-1">
      <div class="row">
        <div class="col-3">
          <b-form-group label="Mes">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="monthsDST"
              class="w-100 datetime-select"
              :reduce="(val) => val.value"
              v-model="itemData.endMonthDst"
              append-to-body
              :clearable="false"
              :disabled="disabledInputsDst"
              :calculate-position="withPopper"
            />
          </b-form-group>
        </div>
        <div class="col-3">
          <b-form-group label="Semana">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="weeksDST"
              class="w-100 datetime-select"
              :reduce="(val) => val.value"
              v-model="itemData.endWeekDst"
              append-to-body
              :clearable="false"
              :disabled="disabledInputsDst"
              :calculate-position="withPopper"
            />
          </b-form-group>
        </div>
        <div class="col-3">
          <b-form-group label="Día">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="daysDST"
              class="w-100 datetime-select"
              :reduce="(val) => val.value"
              v-model="itemData.endDayDst"
              append-to-body
              :clearable="false"
              :disabled="disabledInputsDst"
              :calculate-position="withPopper"
            />
          </b-form-group>
        </div>
        <div class="col-3">
          <b-form-group label="Hora">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="hoursDst"
              class="w-100 datetime-select"
              :reduce="(val) => val.value"
              v-model="itemData.endHourDst"
              append-to-body
              :clearable="false"
              :disabled="disabledInputsDst"
              :calculate-position="withPopper"
            />
          </b-form-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import popperHelper from "@/libs/popper-helper";
import vSelect from "vue-select";

export default {
  props:{
    itemData:{
      type: Object
    },
    loading: {
      type: Boolean
    }
  },
  components: {
    vSelect
  },
  setup (props) {
    //DATA
    const daysDST = [
      { value: 0, label: 'Domingo' },
      { value: 1, label: 'Lunes' },
      { value: 2, label: 'Martes' },
      { value: 3, label: 'Miercoles' },
      { value: 4, label: 'Jueves' },
      { value: 5, label: 'Viernes' },
      { value: 6, label: 'Sabado' }
    ];

    const hoursDst = Array.from({ length: 24 }, (_, index) => ({
      value: index,
      label: `${index}H`
    }));

    const monthsDST = [
      { value: 1, label: 'Enero' },
      { value: 2, label: 'Febrero' },
      { value: 3, label: 'Marzo' },
      { value: 4, label: 'Abril' },
      { value: 5, label: 'Mayo' },
      { value: 6, label: 'Junio' },
      { value: 7, label: 'Julio' },
      { value: 8, label: 'Agosto' },
      { value: 9, label: 'Septiembre' },
      { value: 10, label: 'Octubre' },
      { value: 11, label: 'Noviembre' },
      { value: 12, label: 'Diciembre' }
    ];

    const weeksDST = [
      { value: 1, label: 'Primera' },
      { value: 2, label: 'Segunda' },
      { value: 3, label: 'Tercera' },
      { value: 4, label: 'Cuarta' },
      { value: 5, label: 'Ultima' }
    ];

    //COMPUTED
    const disabledInputsDst = computed(() => (!props.itemData.enableDST || props.loading))

    return {
      daysDST,
      hoursDst,
      monthsDST,
      weeksDST,
      withPopper: popperHelper.withPopper,

      disabledInputsDst
    }
  }
}
</script>

<style lang="scss" scoped>
.border-section {
  border: 1px solid rgba(0, 0, 0, .125);
}

table.table tr th {
  background-color: #f8f9fa;
}
</style>
